import { createContext, useContext, useEffect, useMemo, useState } from "react";

const STORAGE_KEY = "wrypaiauth:v1";
const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  // Load persisted auth (if any)
  const [state, setState] = useState(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : { user: null, token: null };
    } catch {
      return { user: null, token: null };
    }
  });

  const isAuthenticated = Boolean(state?.token || state?.user);

  // Persist on change
  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  }, [state]);

  // Call this from your confirmation-code component on success
  const login = ({ user, token }) => {
    setState({ user: user ?? null, token: token ?? null });
  };

  const logout = () => {
    setState({ user: null, token: null });
    // Optionally call your backend logout endpoint here
  };

  const value = useMemo(
    () => ({ ...state, isAuthenticated, login, logout }),
    [state, isAuthenticated]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within <AuthProvider>");
  return ctx;
}
